import PropTypes from 'prop-types';
import React from 'react';
import StepSatisfyOption from './StepSatisfyOption';
import { SessionSocialReferrerGate } from '../../../../components/dialogue/scenarios/versionTwo/components/scenario_records_2.js';

class StepSessionSocialReferrerGate extends React.Component {
  static propTypes = {
    editing: PropTypes.bool.isRequired,
    data: PropTypes.instanceOf(SessionSocialReferrerGate).isRequired,
    onChange: PropTypes.func.isRequired,
  }

  handleChangeSatisfy = (continueOnSatisfy) => {
    const data = this.props.data.set('continue', continueOnSatisfy);
    this.props.onChange(data);
  }

  render() {
    const continueOnSatisfy = this.props.data.continue ? "Yes" : "No";

    if (!this.props.editing) {
      return (<div>Continue if Session begins with Social Referrer: { continueOnSatisfy }</div>);
    } else {
      return (
        <div className="step continue-halt">
          <label>Continue if Session begins with Social Referrer: </label>
          <StepSatisfyOption
            value={ this.props.data.continue }
            onChange={ this.handleChangeSatisfy }
            focusOnMount={ true }
          />
        </div>
      );
    }
  }
}

export default StepSessionSocialReferrerGate;
